import JeromeData from "../../../../src/components/jerome-data.js";
import * as React from 'react';
export default {
  JeromeData,
  React
};